import { useEffect, useState } from 'react';

import { isEnabled } from 'Config';

const useLoadingScreen = ({
  identifier3ds,
  initialized,
  is3dsComplete,
  loading,
}: {
  identifier3ds?: string;
  initialized: boolean;
  is3dsComplete?: boolean;
  loading: boolean;
}) => {
  const isEnabledLoadingScreen = !isEnabled('skipLoadingScreen');
  const shouldShowLoadingScreen =
    !initialized || loading || (identifier3ds ? !is3dsComplete : false);

  const [showLoadingScreen, setShowLoadingScreen] = useState(isEnabledLoadingScreen);

  useEffect(() => {
    if (!isEnabledLoadingScreen) {
      setShowLoadingScreen(false);
      return;
    }
    setShowLoadingScreen(shouldShowLoadingScreen);
  }, [shouldShowLoadingScreen, isEnabledLoadingScreen]);

  return {
    showLoadingScreen,
  };
};

export default useLoadingScreen;
